const {Core, Events, Utils, MediaQueries} = Global;
const { $toggleDisplay } = Utils;
const CN_ACTIVE = '!active';
const CN_LOADING = '!loading';

customElements.define('sticky-add-to-cart', class extends Core {

    elements = {
        $: ['wrapper']
    }

    propTypes = {
        'sticky-bottom': Boolean
    }

    render() {
        this.sub(Events.VARIANT_CHANGE, this._toggleLoading(true));
        this.sub(Events.VARIANT_UPDATE, this._toggleLoading(false));
        this.sub(Events.VARIANT_UNAVAILABLE, this._handleVariantUnavailability);
        this.sub(Events.VARIANT_UPDATE, this._onVariantUpdate);

        if (this.prop('sticky-bottom')) {
            this._setBodyOffset();
            this._syncScrollToTopOffset(false);
        }

        this._observeMainAtc();
    }

    _onVariantUpdate() {
        this.observer?.disconnect();
        requestAnimationFrame(() => this._observeMainAtc());
    }

    _getMainAtcTrigger() {
        const sectionId = this.getAttribute('section-id');
        return document.querySelector(
            `#productPageContainer-${sectionId} [data-element="main-atc-trigger"]`
        );
    }

    _observeMainAtc() {
        const trigger = this._getMainAtcTrigger();
        if (!trigger) return;

        this.observer?.disconnect();

        this.observer = new IntersectionObserver(([entry]) => {
            const isActive = !entry.isIntersecting;
            this.active = isActive;

            if (MediaQueries.DESKTOP.matches && !this.prop('sticky-bottom')) {
                if (isActive) {
                    document.body.style.setProperty('--sticky-add-to-cart-top-offset',`${this.$('wrapper').offsetHeight}px`);
                } else {
                    document.body.style.setProperty('--sticky-add-to-cart-top-offset', '0px');
                }
            }
        }, { threshold: 0 });

        this.observer.observe(trigger);
    }

    _setBodyOffset() {
        document.body.style.setProperty('--bottom-offset', `${this.$('wrapper').offsetHeight}px`);
    }

    _syncScrollToTopOffset(isActive) {
        const barGap = 6;
        const root = document.documentElement;

        root.style.setProperty(
            '--scroll-to-top-extra-bottom',
            isActive ? `${this.$('wrapper').offsetHeight + barGap}px` : '0px'
        );

        if (isActive) {
            root.style.setProperty('--scroll-to-top-gap', '0.5rem');
        } else {
            root.style.removeProperty('--scroll-to-top-gap');
        }
    }

    _toggleLoading(state) {
        return () => {
            this.classList.toggle(CN_LOADING, state);
        }
    }

    _handleVariantUnavailability(state) {
        $toggleDisplay(this, !state);
    }

    set active(state) {
        this.classList.toggle(CN_ACTIVE, state);

        if (this.prop('sticky-bottom')) {
            this._setBodyOffset();
            this._syncScrollToTopOffset(state);
        }
    }
})
